module.exports = __webpack_public_path__ + "static/img/logo.20d169f3.svg";